'use client';

import React from 'react';
import { Dialog } from '@headlessui/react';
import { Button } from '@/components/common/Button';

interface CancelSubscriptionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tenantName: string;
  loading: boolean;
}

export const CancelSubscriptionDialog: React.FC<CancelSubscriptionDialogProps> = ({ open, onClose, onConfirm, tenantName, loading }) => {
  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-lg w-full rounded-lg bg-white p-6">
          <Dialog.Title className="text-lg font-medium text-red-900">
            Cancel Subscription for {tenantName}
          </Dialog.Title>

          <div className="mt-4">
            <p className="text-sm text-gray-600">
              Are you sure you want to immediately cancel the Stripe subscription for this tenant? This action is irreversible.
            </p>
          </div>

          <div className="mt-6 flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button variant="destructive" onClick={onConfirm} disabled={loading}>
              {loading ? 'Canceling...' : 'Confirm Cancellation'}
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
